<template>
  <div>
    <div ref="nonModalRoot">
      <transition name="fade">
        <div v-show="!showJourneyOverlay">
          <component v-if="template" v-bind:is="template" v-bind="templateProps">
            <keep-alive max="1" include="ResourceList">
              <router-view />
            </keep-alive>
          </component>
          <router-view v-else />
        </div>
      </transition>
      <transition name="fade">
        <JourneyContainer
          v-if="currentUser && currentUser.journeys_visible"
          v-show="showJourneyOverlay"
        ></JourneyContainer>
      </transition>
      <modal
        class="community-video-modal"
        v-if="$store.state.communityPlayingVideo"
        @dismiss="$store.commit('setCommunityPlayingVideo', null)"
      >
        <brightcove-video
          :id="$store.state.communityPlayingVideo.brightcove_id"
          @play="recordVideoPlay"
        />
      </modal>
    </div>
    <portal-target name="modals" @change="handlePortalChange" />
  </div>
</template>

<style lang="less">
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to,
.fade-leave-active {
  opacity: 0;
}
.swal-modal {
  .swal-title {
    color: #000;
    //text-align: left;
  }
  .swal-text {
    color: #000;
    //text-align: left;
  }
  .swal-button {
    background: #333;
    font-weight: normal;
    &:hover {
      background: #000;
    }
    &.swal-button--cancel {
      background: #dedede;
      color: #000;
      &:hover {
        background: #ccc;
      }
    }
  }
}

.community-video-modal .n-modal-container {
  max-width: 780px;
  width: 95%;
}

.buttons {
  margin-top: 35px;
  .lp-btn {
    cursor: pointer;
    width: auto;
    border-radius: 2px;
  }
}

img.flair {
  height: 18px;
  display: inline-block;
  margin-right: 0px;
  vertical-align: baseline;
  position: relative;
  top: 3px;
}

.sr-only {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>

<script>
import $ from "jquery";
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import BrightcoveVideo from "@/common/components/BrightcoveVideo";
import Modal from "@/common/components/Modal";
import JourneyContainer from "@/journeys/JourneyContainer";

export default {
  watch: {
    currentEdition() {
      this.setCustomGA();
    },
    $route(to, from) {
      // Go to Journey view when opening link from a Journey notification
      if (to.query.journey) {
        this.$store.commit(
          "setSelectedJourney",
          parseInt(this.$route.query.journey)
        );
        this.$store.commit("setShowJourney", true);
      } else if (from.query.journey) {
        this.$store.commit("setShowJourney", false);
      }
    },
  },
  mounted() {
    if (this.currentEdition) {
      this.setCustomGA();
    }
  },
  methods: {
    recordVideoPlay() {
      let videoId = this.$store.state.communityPlayingVideo.id;
      axios.post(`/community/api/user_videos/${videoId}/views`);
    },
    setCustomGA() {
      if (this.currentEdition.gtm_container_id && !window.dataLayer) {
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
          j.async = true;
          j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
          f.parentNode.insertBefore(j, f);
        })(
          window,
          document,
          "script",
          "dataLayer",
          this.currentEdition.gtm_container_id
        );
      }

      if (
        this.currentEdition.tracking_snippet &&
        !window.insertedTrackingSnippet
      ) {
        let script = document.createElement("script");
        script.innerHTML = this.currentEdition.tracking_snippet;
        document.head.append(script);
        window.insertedTrackingSnippet = true;
      }
    },
    handlePortalChange(hasContent) {
      if (hasContent) {
        this.$refs.nonModalRoot.setAttribute("inert", true);
      } else {
        this.$refs.nonModalRoot.removeAttribute("inert");
      }
    },
  },
  computed: {
    template() {
      if (this.$route.meta) {
        return this.$route.meta.template;
      }
    },
    templateProps() {
      if (this.$route.meta) {
        return this.$route.meta.templateProps;
      }
    },
    showJourneyOverlay() {
      return this.showJourney || this.showJourneys;
    },
    ...mapState({
      showJourney: (state) => state.journeys.showJourney,
      showJourneys: (state) => state.journeys.showJourneys,
    }),
    ...mapGetters(["currentEdition", "currentUser"]),
  },
  components: {
    BrightcoveVideo,
    Modal,
    JourneyContainer,
  },
};
</script>
